<template>
  <div class="deletion-group-modal">
    <!-- RECURRING DELETION MODAL -->
    <common-modal
      :name="recurDeletionModalCfg.name"
      :title="recurDeletionModalCfg.title"
      :primaryAction="recurDeletionModalCfg.primaryAction"
      :secondaryActions="recurDeletionModalCfg.secondaryActions"
      height="auto"
      v-if="eventType === EVENT_TYPES.classEvent"
    >
      <template #modal-body>
        <div class="md-layout">
          <div
            v-for="type in deletingTypeOpts"
            :key="'deleting-type-' + type.value"
            class="md-layout-item md-size-100"
          >
            <md-radio v-model="deletingType" :value="type.value">{{
              type.title
            }}</md-radio>
          </div>
        </div>
      </template>
    </common-modal>
    <!-- RECURRING DELETION MODAL -->

    <!-- CONFIRM EVENT DELETION -->
    <common-modal
      :name="cfmDeletionModalCfg.name"
      :title="cfmDeletionModalCfg.title"
      :primaryAction="cfmDeletionModalCfg.primaryAction"
      :secondaryActions="cfmDeletionModalCfg.secondaryActions"
      height="auto"
      v-else
    >
      <template #modal-body>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 mt-2">
            <p class="text-gray-600 text-lg">
              {{ $t("schedule.confirm_delete") }}
            </p>
          </div>
        </div>
      </template>
    </common-modal>
    <!-- CONFIRM EVENT DELETION -->

    <common-modal
      name="delete-canceled-meeting"
      :title="cfmDeletionModalCfg.title"
      :primaryAction="cfmDeletionModalCfg.primaryAction"
      :secondaryActions="cfmDeletionModalCfg.secondaryActions"
      height="auto"
      v-if="eventType === EVENT_TYPES.canceled"
    >
      <template #modal-body>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 mt-2">
            <p class="text-gray-600 text-lg">
              {{ $t("schedule.confirm_delete") }}
            </p>
          </div>
        </div>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { EVENT_TYPES, SCHEDULE_TYPES } from "../event-utils";
import { getId, Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";

const DELETION_MODAL_NAME = {
  [EVENT_TYPES.classEvent]: "cfm-recur-deletion-modal",
  [EVENT_TYPES.schoolEvent]: "cfm-deletion-modal",
  [EVENT_TYPES.meetingEvent]: "cfm-deletion-modal"
};

export default {
  props: ["selectedEvent"],
  data() {
    return {
      recurDeletionModalCfg: {
        name: DELETION_MODAL_NAME[EVENT_TYPES.classEvent],
        title: this.$t("schedule.delete_recurring"),
        primaryAction: {
          title: this.$t("common.ok"),
          action: this.deleteEvent,
          disabled: false
        },
        secondaryActions: [
          {
            title: this.$t("common.cancel"),
            action: () => {
              this.hide();
            }
          }
        ]
      },
      cfmDeletionModalCfg: {
        name: DELETION_MODAL_NAME[EVENT_TYPES.schoolEvent],
        title: this.$t("schedule.delete_event"),
        primaryAction: {
          title: this.$t("common.delete"),
          action: this.deleteEvent,
          class: "md-danger"
        },
        secondaryActions: [
          {
            title: this.$t("common.cancel"),
            action: () => {
              this.hide();
            }
          }
        ]
      },
      deletingTypeOpts: Object.values(SCHEDULE_TYPES),
      deletingType: "",
      EVENT_TYPES
    };
  },
  inject: ["refetchEvents"],
  computed: {
    eventType() {
      const eventData = this.selectedEvent?.event;

      const eventType = eventData?.extendedProps?.type;

      return eventType || EVENT_TYPES.schoolEvent;
    },
    eventId() {
      const eventData = this.selectedEvent?.event;

      return getId(eventData?.extendedProps);
    }
  },
  watch: {
    deletingType(newDeletingType) {
      this.recurDeletionModalCfg.primaryAction.disabled = !newDeletingType;
    }
  },
  methods: {
    hide(modalName) {
      this.$modal.hide(modalName || DELETION_MODAL_NAME[this.eventType]);
      if (this.eventType === EVENT_TYPES.canceled) {
        this.$modal.hide("delete-canceled-meeting");
      }
    },
    open() {
      this.deletingType =
        this.eventType === EVENT_TYPES.schoolEvent
          ? SCHEDULE_TYPES.singleEvent.value
          : "";
      this.$modal.show(DELETION_MODAL_NAME[this.eventType]);
      if (this.eventType === EVENT_TYPES.canceled) {
        this.$modal.show("delete-canceled-meeting");
      }
    },
    deleteEvent() {
      if (
        this.eventType === EVENT_TYPES.meetingEvent ||
        this.eventType === EVENT_TYPES.canceled
      ) {
        this.deleteVirtualMetting();
      } else {
        this.$axios
          .patch(`${service_paths.calendars}/${this.eventId}/delete`, {
            option: this.deletingType
          })
          .then(() => {
            this.refetchEvents();
            Message.success(this.$t("schedule.delete_event_successfully"));
          });
      }
      this.hide();
    },
    deleteVirtualMetting() {
      this.$axios
        .delete(
          `${service_paths.calendars}/${this.eventId}/${
            this.eventType === EVENT_TYPES.canceled
              ? "canceled"
              : "video-conference"
          }`
        )
        .then(() => {
          this.refetchEvents();
          Message.success(this.$t("schedule.delete_meeting_successfully"));
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
